import { SelectorOption } from 'types';

type CheckIsDisabledAddCoOwnerButtonProps = {
  selectedPartner: SelectorOption | null;
  name: string;
  cif: string;
  isValidPercent: boolean;
  isValidEmail: boolean;
};

export const checkIsDisabledAddCoOwnerButton = ({
  selectedPartner,
  name,
  cif,
  isValidPercent,
  isValidEmail,
}: CheckIsDisabledAddCoOwnerButtonProps): boolean =>
  (!name && !selectedPartner) || !cif || !isValidPercent || !isValidEmail;
